const constants =  {
  core_service_domain: process.env.REACT_APP_CORE_SERVICE,
  client_credential_id: process.env.REACT_APP_CLIENT_CREDENTIAL_ID,
  client_credential_secret: process.env.REACT_APP_CLIENT_CREDENTIAL_SECRET,
  client_auth_method: process.env.REACT_APP_CLIENT_AUTH_METHOD,
  auth_server_url: process.env.REACT_APP_AUTH_SERVER_URL,
  billing_url: process.env.REACT_APP_BILLING_URL,
  billing_service_type: process.env.REACT_APP_BILLING_SERVICE_TYPE,
  billing_service_name: process.env.REACT_APP_BILLING_SERVICE_NAME,
  s3URL: process.env.REACT_APP_S3_URL,
  s3Bucket: process.env.REACT_APP_S3_BUCKET,
  adminUiARecord: process.env.REACT_APP_ADMIN_UI_A_RECORD,
  adminUiCNameRecord: process.env.REACT_APP_ADMIN_UI_CNAME_RECORD,
  customerUiARecord: process.env.REACT_APP_CUSTOMER_UI_A_RECORD,
  customerUiCNameRecord: process.env.REACT_APP_CUSTOMER_CNAME_RECORD,
  google_reCapcha_site_key: process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY,
  google_reCapcha_secret_key: process.env.REACT_APP_GOOGLE_RECAPTCHA_SECRET_KEY,
  google_reCapcha_url: '/recaptcha/api/siteverify',
  unAuthorizedStatusCode: 401,
  xlBreakpoint: 1536,
  lgBreakpoint: 1200,
  mdBreakpoint: 900,
  smBreakpoint: 600,
  notifications_limit: 10,
  latest_notifications_limit: 5,
  iSenderURL: process.env.REACT_APP_ISENDER_URL,
  paypalClientId: process.env.REACT_APP_PAYPAL_CLIENTID,
  paypalCurrency: process.env.REACT_APP_PAYPAL_CURRENCY,
  app_version: '0.1.24',
}

export default constants